// /**
//  * driver - Add
//  */

// React
import React, { useState, useContext, useEffect } from 'react';

// react hook form
import { useForm } from 'react-hook-form';

// UI
import theme from '../../../theme';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@material-ui/core';
import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiPhoneOutline,
  mdiMapMarkerOutline,
  mdiArrowRight,
  mdiFormatListCheckbox,
  mdiAccountOutline,
  mdiCarMultiple,
  mdiCardAccountDetailsOutline,
  mdiCalendarToday,
  mdiBank,
  mdiClipboardTextMultipleOutline,
  mdiFormatColorFill,
  mdiOrderNumericAscending,
  mdiCounter,
  mdiGasStationOutline,
  mdiPencil,
  mdiPostOutline,
  mdiCurrencyUsd,
} from '@mdi/js';

// Type
import { SelectorProps } from './interfaces';

// helpers'
import {
  flattenObject,
  removeEmptyValueObject,
  convertPersianDigit2English,
  translate,
} from '../../../utils/helpers';
import {
  updateDriverActions,
  getDriverAction,
} from '../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Store } from '../../../redux/reducers';
import {
  makeSelectError,
  makeSelectLoading,
  makeSelectDriver,
} from '../selectors';

import { useHistory } from 'react-router-dom';
import { Payload } from '../interfaces';
import JalaliUtils from '@date-io/jalaali';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import Plate from '../plate';
import MotorPlate from '../motorPlate';

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

type Props = {
  match: {
    params: {
      id: number;
      fleetId: number;
    };
  };
  driver: any;
  updateDriverDispatch: (payload: Payload) => void;
  getDriverWithIdActionDispatch: (id: number) => void;
};

type Inputs = {
  bank: string;
  fuel: string;
  name: string;
  phoneNumber: string;
  homePhoneNumber: string;
  address: string;
  warrantyAmount: number;
  warrantyType: string;
  bankAccountNumber: string;
  shabaNumber: string;
  plateNumber: string;
  nationalCode: string;
  color: string;
  productionYear: string;
  vehicleType: string;
  employmentStartDate: string;
  birthDate: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& .MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    '.margin-date-0': {
      '&.MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    errorText: {
      color: '#F30000',
      fontSize: '11px',
    },
    errorPlate: {
      marginTop: '20px',
      marginLeft: '15px',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

function useOnMount(handler: any) {
  return React.useEffect(handler, []);
}

function required(displayName: any) {
  return function validateRequired(value: any) {
    return value !== null || `${displayName} is required.`;
  };
}

function Index(props: Props) {
  const classes = useStyles();
  const { register, handleSubmit, errors, watch, setValue, getValues } = useForm<
    Inputs
  >({
    mode: 'onChange',
    defaultValues: {
      employmentStartDate: null,
      birthDate: null,
    },
  });
  const [employmentType, setEmploymentType] = useState<any>('');
  const [vehicleClass, setVehicleClass] = useState<any>('');
  const [platePattern, setPlatePattern] = useState<any>('');

  const history = useHistory();

  const vehicleTypes = [
    'CAR',
    'MOTORCYCLE',
    'PICKUPS',
    'TRUCK',
    'HEAVY_TRUCK',
    'AIRPLANE',
  ];

  const employmentTypes = ['FULL_TIME', 'PART_TIME'];

  const checkEmptyInputs = (): boolean => {
    const values = [vehicleClass, employmentType];
    const emptyValues =
      Object.keys(flattenObject(removeEmptyValueObject({ ...watch() })))
        .length !== 13;
    return emptyValues && values.some(value => !value);
  };

  const onSubmit = (data: Inputs) => {
    const phoneAddressObj: any = {};

    const {
      bank,
      bankAccountNumber,
      shabaNumber,
      plateNumber,
      color,
      productionYear,
      employmentStartDate,
      vehicleType,
      name,
      fuel,
      phoneNumber,
      homePhoneNumber,
      address,
      warrantyAmount,
      warrantyType,
      nationalCode,
      birthDate,
    } = data;

    if (address.length) {
      phoneAddressObj.address = address;
    }

    if (homePhoneNumber.length) {
      phoneAddressObj.homePhoneNumber = homePhoneNumber;
    }

    const inputData = {
      bank,
      bankAccountNumber,
      shabaNumber,
      plateNumber,
      color,
      fuel,
      productionYear,
      employmentStartDate,
      vehicleType,
      name,
      phoneNumber,
      ...phoneAddressObj,
      warrantyAmount,
      warrantyType,
      vehicleClass,
      employmentType,
      nationalCode,
      birthDate,
      employmentStatus: 'ACTIVE',
      fleetId: props.match.params.fleetId,
      id: props.match.params.id,
      vehicleId: props.driver.vehicleId,
      userId: props.driver.userId,
    };
    handleCreateParcel(inputData);
  };

  useOnMount(() => {
    register(
      { name: 'birthDate', type: 'text', defaultValue: '' },
      { validate: required('تاریخ تولد را وارد کنید') }
    );
    register(
      { name: 'employmentStartDate', type: 'text', defaultValue: '' },
      { validate: required(' تاریخ آغاز به کار را وارد کنید') }
    );
  });

  const handleEmploymentStartChange = (date: any) => {
    setValue(
      'employmentStartDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
  };

  const handleBirthDateChange = (date: any) => {
    setValue(
      'birthDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
  };

  const handleCreateParcel = (driverData: any) => {
    props.updateDriverDispatch({
      body: driverData,
      callback: () =>
        history.push(`/fleets/${props.match.params.fleetId}/drivers`),
    });
  };

  useEffect(() => {
    setPlatePattern(/^\d{2}[\u0600-\u06FF]\d{3}\-\d{2}$/g);
    if (vehicleClass === 'MOTORCYCLE') {
      setPlatePattern(/^\d{8}$/g);
    }
  }, [vehicleClass])

  useEffect(() => {
    const id = props.match.params.id;
    props?.getDriverWithIdActionDispatch(id);
  }, []);

  useEffect(() => {
    if (props?.driver?.id) {
      setValue('name', props.driver.name);
      setValue('color', props.driver.color);
      setValue('plateNumber', props.driver.plateNumber);
      setValue('productionYear', props.driver.productionYear);
      setValue('employmentStartDate', props.driver.employmentStartDate);
      setValue('fuel', props.driver.fuel);
      setValue('vehicleType', props.driver.vehicleType);
      setValue('birthDate', props.driver.birthDate);
      setValue('nationalCode', props.driver.nationalCode);
      setValue('bank', props.driver.bank);
      setValue('bankAccountNumber', props.driver.bankAccountNumber);
      setValue('shabaNumber', props.driver.shabaNumber);
      setValue('phoneNumber', props.driver.phoneNumber);
      setValue('homePhoneNumber', props.driver.homePhoneNumber);
      setValue('warrantyAmount', props.driver.warrantyAmount);
      setValue('warrantyType', props.driver.warrantyType);
      setValue('address', props.driver.address);
      setEmploymentType(props.driver.employmentType);
      setVehicleClass(props.driver.vehicleClass);
    }
  }, [props?.driver]);

  const values = getValues();

  return (
    <>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        ویرایش اطلاعات راننده - 
        ${props.match.params.id}
        `}
        </Typography>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>
      </Grid>
      <form style={{ display: 'flex' }} onSubmit={handleSubmit(onSubmit)}>
        <Grid container style={{ margin: 0 }} spacing={5} alignItems="flex-start">
          <Paper
            elevation={3}
            className={classes.paper}
            variant="elevation"
            square
          >
            <div style={{ marginTop: '-66px' }} className={classes.addIcon}>
              <Icon path={mdiPencil} size={4} color={theme.palette.blue.main} />
            </div>
            <Grid
              style={{ padding: '30px 20px' }}
              container
              spacing={5}
              alignItems="flex-start"
            >
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiAccountOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="name"
                      name="name"
                      label="نام راننده"
                      InputLabelProps={{
                        shrink: !!props.driver.name || !!values.name,
                      }}
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        minLength: 5,
                        maxLength: 25,
                      })}
                      error={errors.name && true}
                    />
                    {errors.name && errors.name.type === 'required' && (
                      <p className={classes.errorText}>
                        {'فیلد نام راننده الزامیست'}
                      </p>
                    )}
                    {errors.name && errors.name.type === 'minLength' && (
                      <p className={classes.errorText}>
                        {'مقدار نام راننده نباید کمتر از 5 کاراکتر باشد'}
                      </p>
                    )}
                    {errors.name && errors.name.type === 'maxLength' && (
                      <p className={classes.errorText}>
                        {'مقدار نام راننده نباید بیشتر از 25 کاراکتر باشد'}
                      </p>
                    )}
                  </Grid>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendarToday}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <div className="margin-date-0" style={{ width: '100%' }}>
                    <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                      <DatePicker
                        id="birthDate"
                        name="birthDate"
                        label="تاریخ تولد"
                        format="jYYYY/jMM/jDD"
                        margin="normal"
                        disableFuture
                        style={{ marginTop: 0 }}
                        disableToolbar
                        fullWidth
                        InputLabelProps={{
                          shrink:
                            !!props.driver.birthDate || !!values.birthDate,
                        }}
                        okLabel="تأیید"
                        cancelLabel="لغو"
                        defaultValue={null}
                        className={classes.textInput}
                        value={values.birthDate}
                        onChange={handleBirthDateChange}
                        error={errors.hasOwnProperty('birthDate')}
                        helperText={
                          errors.birthDate && errors.birthDate.message
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiCounter} size={1} className={classes.icon} />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="nationalCode"
                      name="nationalCode"
                      label="کد ملی"
                      InputLabelProps={{
                        shrink:
                          !!props.driver.nationalCode || !!values.nationalCode,
                      }}
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        pattern: /^\d{10}$/g,
                        minLength: 10,
                        maxLength: 10,
                      })}
                      error={errors.nationalCode && true}
                    />
                    {errors.nationalCode &&
                      errors.nationalCode.type === 'required' && (
                        <p className={classes.errorText}>
                          {'فیلد کد ملی الزامیست'}
                        </p>
                      )}
                    {errors.nationalCode &&
                      errors.nationalCode.type === 'pattern' && (
                        <p className={classes.errorText}>
                          {'فرمت فیلد کد ملی صحیح نیست'}
                        </p>
                      )}
                    {errors.nationalCode &&
                      errors.nationalCode.type === 'minLength' && (
                        <p className={classes.errorText}>
                          {'مقدار کد ملی نباید کمتر از 10 کاراکتر باشد'}
                        </p>
                      )}
                    {errors.nationalCode &&
                      errors.nationalCode.type === 'maxLength' && (
                        <p className={classes.errorText}>
                          {'مقدار کد ملی نباید بیشتر از 10 کاراکتر باشد'}
                        </p>
                      )}
                  </Grid>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPhoneOutline}
                      size={1}
                      className={classes.icon}
                      style={{ transform: 'scale(-1, 1)' }}
                    />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="phoneNumber"
                      name="phoneNumber"
                      label="شماره تماس"
                      InputLabelProps={{
                        shrink:
                          !!props.driver.phoneNumber || !!values.phoneNumber,
                      }}
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        pattern: /^(\+989|09)\d{9}$/g,
                        minLength: 11,
                        maxLength: 15,
                      })}
                      error={errors.phoneNumber && true}
                    />
                    {errors.phoneNumber &&
                      errors.phoneNumber.type === 'required' && (
                        <p className={classes.errorText}>
                          {'فیلد شماره تماس الزامیست'}
                        </p>
                      )}
                    {errors.phoneNumber &&
                      errors.phoneNumber.type === 'pattern' && (
                        <p className={classes.errorText}>
                          {'فرمت فیلد شماره تماس صحیح نیست'}
                        </p>
                      )}
                    {errors.phoneNumber &&
                      errors.phoneNumber.type === 'minLength' && (
                        <p className={classes.errorText}>
                          {'مقدار شماره تماس نباید کمتر از 11 کاراکتر باشد'}
                        </p>
                      )}
                    {errors.phoneNumber &&
                      errors.phoneNumber.type === 'maxLength' && (
                        <p className={classes.errorText}>
                          {'مقدار شماره تماس نباید بیشتر از 15 کاراکتر باشد'}
                        </p>
                      )}
                  </Grid>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCardAccountDetailsOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{ width: '100%' }}>
                    <FormControl style={{ width: '100%' }}>
                      <InputLabel id="employmentTypeLabel">
                        نوع همکاری
                      </InputLabel>
                      <Select
                        fullWidth
                        id="employmentType"
                        name="employmentType"
                        inputProps={{
                          name: 'employmentType',
                          id: 'employmentType',
                        }}
                        labelId="employmentTypeLabel"
                        value={employmentType}
                        onChange={e => setEmploymentType(e.target.value)}
                        className={classes.textInput}
                        inputRef={register({ required: true })}
                      >
                        {employmentTypes.map((item: any) => {
                          return (
                            <MenuItem key={item} value={item}>
                              {translate(item)}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>{' '}
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendarToday}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <div className="margin-date-0" style={{ width: '100%' }}>
                    <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                      <DatePicker
                        id="employmentStartDate"
                        name="employmentStartDate"
                        label="تاریخ آغاز به کار"
                        format="jYYYY/jMM/jDD"
                        margin="normal"
                        style={{ marginTop: 0 }}
                        disableToolbar
                        fullWidth
                        okLabel="تأیید"
                        InputLabelProps={{
                          shrink:
                            !!props.driver.employmentStartDate ||
                            !!values.employmentStartDate,
                        }}
                        cancelLabel="لغو"
                        defaultValue={null}
                        className={classes.textInput}
                        value={values.employmentStartDate}
                        onChange={handleEmploymentStartChange}
                        error={errors.hasOwnProperty('employmentStartDate')}
                        helperText={
                          errors.employmentStartDate &&
                          errors.employmentStartDate.message
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiBank} size={1} className={classes.icon} />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="bank"
                      name="bank"
                      label="نام بانک"
                      InputLabelProps={{
                        shrink: !!props.driver.bank || !!values.bank,
                      }}
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        minLength: 2,
                        maxLength: 20,
                      })}
                      error={errors.bank && true}
                    />
                    {errors.bank && errors.bank.type === 'required' && (
                      <p className={classes.errorText}>
                        {'فیلد نام بانک الزامیست'}
                      </p>
                    )}
                    {errors.bank && errors.bank.type === 'minLength' && (
                      <p className={classes.errorText}>
                        {'مقدار نام بانک نباید کمتر از 2 کاراکتر باشد'}
                      </p>
                    )}
                    {errors.bank && errors.bank.type === 'maxLength' && (
                      <p className={classes.errorText}>
                        {'مقدار نام بانک نباید بیشتر از 20 کاراکتر باشد'}
                      </p>
                    )}
                  </Grid>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiClipboardTextMultipleOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{ width: '100%' }}>
                    <TextField
                      fullWidth
                      id="bankAccountNumber"
                      name="bankAccountNumber"
                      label="شماره حساب"
                      InputLabelProps={{
                        shrink:
                          !!props.driver.bankAccountNumber ||
                          !!values.bankAccountNumber,
                      }}
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        pattern: /^(\d+\-)*\d+$/g,
                        minLength: 10,
                        maxLength: 30,
                      })}
                      error={errors.bankAccountNumber && true}
                    />
                    {errors.bankAccountNumber &&
                      errors.bankAccountNumber.type === 'required' && (
                        <p className={classes.errorText}>
                          {'فیلد شماره حساب الزامیست'}
                        </p>
                      )}
                    {errors.bankAccountNumber &&
                      errors.bankAccountNumber.type === 'pattern' && (
                        <p className={classes.errorText}>
                          {'فرمت فیلد شماره حساب صحیح نیست'}
                        </p>
                      )}
                    {errors.bankAccountNumber &&
                      errors.bankAccountNumber.type === 'minLength' && (
                        <p className={classes.errorText}>
                          {'مقدار شماره حساب نباید کمتر از 10 کاراکتر باشد'}
                        </p>
                      )}
                    {errors.bankAccountNumber &&
                      errors.bankAccountNumber.type === 'maxLength' && (
                        <p className={classes.errorText}>
                          {'مقدار شماره حساب نباید بیشتر از 30 کاراکتر باشد'}
                        </p>
                      )}
                  </span>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiClipboardTextMultipleOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{ width: '100%' }}>
                    <TextField
                      fullWidth
                      id="shabaNumber"
                      name="shabaNumber"
                      label="شماره شبا"
                      InputLabelProps={{
                        shrink:
                          !!props.driver.shabaNumber || !!values.shabaNumber,
                      }}
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        minLength: 10,
                        maxLength: 30,
                      })}
                      error={errors.shabaNumber && true}
                    />
                    {errors.shabaNumber &&
                      errors.shabaNumber.type === 'required' && (
                        <p className={classes.errorText}>
                          {'فیلد شماره شبا الزامیست'}
                        </p>
                      )}
                    {errors.shabaNumber &&
                      errors.shabaNumber.type === 'minLength' && (
                        <p className={classes.errorText}>
                          {'مقدار شماره شبا نباید کمتر از 10 کاراکتر باشد'}
                        </p>
                      )}
                    {errors.shabaNumber &&
                      errors.shabaNumber.type === 'maxLength' && (
                        <p className={classes.errorText}>
                          {'مقدار شماره شبا نباید بیشتر از 30 کاراکتر باشد'}
                        </p>
                      )}
                  </span>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCarMultiple}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{ width: '100%' }}>
                    <FormControl style={{ width: '100%' }}>
                      <InputLabel id="vehicleClassLabel">نوع خودرو</InputLabel>
                      <Select
                        fullWidth
                        id="vehicleClass"
                        name="vehicleClass"
                        inputProps={{
                          name: 'vehicleClass',
                          id: 'vehicleClass',
                        }}
                        labelId="vehicleClassLabel"
                        value={vehicleClass}
                        onChange={e => setVehicleClass(e.target.value)}
                        className={classes.textInput}
                        inputRef={register({ required: true })}
                      >
                        {vehicleTypes.map((item: any) => {
                          return (
                            <MenuItem key={item} value={item}>
                              {translate(item)}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiFormatListCheckbox}
                      size={1}
                      className={classes.icon}
                      style={{ transform: 'rotate(-180deg)' }}
                    />
                  </span>

                  <span style={{ width: '100%' }}>
                    <TextField
                      fullWidth
                      id="vehicleType"
                      name="vehicleType"
                      label="مدل خودرو"
                      InputLabelProps={{
                        shrink:
                          !!props.driver.vehicleType || !!values.vehicleType,
                      }}
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        minLength: 2,
                        maxLength: 20,
                      })}
                      error={errors.vehicleType && true}
                    />
                    {errors.vehicleType &&
                      errors.vehicleType.type === 'required' && (
                        <p className={classes.errorText}>
                          {'فیلد مدل خودرو الزامیست'}
                        </p>
                      )}
                    {errors.vehicleType &&
                      errors.vehicleType.type === 'minLength' && (
                        <p className={classes.errorText}>
                          {'مقدار مدل خودرو نباید کمتر از 2 کاراکتر باشد'}
                        </p>
                      )}
                    {errors.vehicleType &&
                      errors.vehicleType.type === 'maxLength' && (
                        <p className={classes.errorText}>
                          {'مقدار مدل خودرو نباید بیشتر از 20 کاراکتر باشد'}
                        </p>
                      )}
                  </span>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiGasStationOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="fuel"
                      name="fuel"
                      label="نوع سوخت"
                      InputLabelProps={{
                        shrink: !!props.driver.fuel || !!values.fuel,
                      }}
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        minLength: 2,
                        maxLength: 20,
                      })}
                      error={errors.fuel && true}
                    />
                    {errors.fuel && errors.fuel.type === 'required' && (
                      <p className={classes.errorText}>
                        {'فیلد نوع سوخت الزامیست'}
                      </p>
                    )}
                    {errors.fuel && errors.fuel.type === 'minLength' && (
                      <p className={classes.errorText}>
                        {'مقدار نوع سوخت نباید کمتر از 2 کاراکتر باشد'}
                      </p>
                    )}
                    {errors.fuel && errors.fuel.type === 'maxLength' && (
                      <p className={classes.errorText}>
                        {'مقدار نوع سوخت نباید بیشتر از 20 کاراکتر باشد'}
                      </p>
                    )}
                  </Grid>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendarToday}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{ width: '100%' }}>
                    <TextField
                      fullWidth
                      id="productionYear"
                      name="productionYear"
                      label="سال ساخت"
                      InputLabelProps={{
                        shrink:
                          !!props.driver.productionYear ||
                          !!values.productionYear,
                      }}
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        pattern: /^(13[0-9][0-9]|14[0-9][0-9])$/g,
                        minLength: 4,
                        maxLength: 4,
                      })}
                      error={errors.productionYear && true}
                    />
                    {errors.productionYear &&
                      errors.productionYear.type === 'required' && (
                        <p className={classes.errorText}>
                          {'فیلد سال ساخت الزامیست'}
                        </p>
                      )}
                    {errors.productionYear &&
                      errors.productionYear.type === 'pattern' && (
                        <p className={classes.errorText}>
                          {'فرمت فیلد سال ساخت صحیح نیست'}
                        </p>
                      )}
                    {errors.productionYear &&
                      errors.productionYear.type === 'minLength' && (
                        <p className={classes.errorText}>
                          {'مقدار سال ساخت نباید کمتر از 4 کاراکتر باشد'}
                        </p>
                      )}
                    {errors.productionYear &&
                      errors.productionYear.type === 'maxLength' && (
                        <p className={classes.errorText}>
                          {'مقدار سال ساخت نباید بیشتر از 4 کاراکتر باشد'}
                        </p>
                      )}
                  </span>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiFormatColorFill}
                      size={1}
                      className={classes.icon}
                      style={{ transform: 'scale(-1, 1)' }}
                    />
                  </span>

                  <span style={{ width: '100%' }}>
                    <TextField
                      fullWidth
                      id="color"
                      name="color"
                      label="رنگ خودرو"
                      InputLabelProps={{
                        shrink: !!props.driver.color || !!values.color,
                      }}
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        minLength: 2,
                        maxLength: 20,
                      })}
                      error={errors.color && true}
                    />
                    {errors.color && errors.color.type === 'required' && (
                      <p className={classes.errorText}>
                        {'فیلد رنگ خودرو الزامیست'}
                      </p>
                    )}
                    {errors.color && errors.color.type === 'minLength' && (
                      <p className={classes.errorText}>
                        {'مقدار رنگ خودرو نباید کمتر از 2 کاراکتر باشد'}
                      </p>
                    )}
                    {errors.color && errors.color.type === 'maxLength' && (
                      <p className={classes.errorText}>
                        {'مقدار رنگ خودرو نباید بیشتر از 20 کاراکتر باشد'}
                      </p>
                    )}
                  </span>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiOrderNumericAscending}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{ width: '100%' }}>
                    {
                      vehicleClass === 'MOTORCYCLE' ? (
                        <MotorPlate
                          getNumber={number => setValue('plateNumber', number)}
                          number={values.plateNumber}
                        />
                      ) : (
                        <Plate
                          getNumber={number => setValue('plateNumber', number)}
                          number={values.plateNumber}
                        />
                      )
                    }
                    <TextField
                      fullWidth
                      id="plateNumber"
                      name="plateNumber"
                      style={{ display: 'none' }}
                      label="پلاک خودرو"
                      InputLabelProps={{
                        shrink:
                          !!props.driver.plateNumber || !!values.plateNumber,
                      }}
                      className={classes.textInput}
                      inputRef={register({
                        required: true,
                        pattern: platePattern,
                        minLength: vehicleClass === 'MOTORCYCLE' ? 8 : 9,
                        maxLength: vehicleClass === 'MOTORCYCLE' ? 8 : 9,
                      })}
                      error={errors.plateNumber && true}
                    />
                    <div className={classes.errorPlate}>
                      {values.plateNumber &&
                        !values.plateNumber.match(platePattern) && (
                          <p className={classes.errorText}>
                            {'فرمت فیلد پلاک خودرو صحیح نیست'}
                          </p>
                        )}
                    </div>
                  </span>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPhoneOutline}
                      size={1}
                      className={classes.icon}
                      style={{ transform: 'scale(-1, 1)' }}
                    />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="homePhoneNumber"
                      name="homePhoneNumber"
                      label="شماره ثابت"
                      className={classes.textInput}
                      InputLabelProps={{
                        shrink:
                          !!props.driver.homePhoneNumber ||
                          !!values.homePhoneNumber,
                      }}
                      inputRef={register({
                        required: false,
                        pattern: /^([+]+98|0)\d{5,10}$/g,
                        minLength: 11,
                        maxLength: 15,
                      })}
                      error={errors.homePhoneNumber && true}
                    />
                    {errors.homePhoneNumber &&
                      errors.homePhoneNumber.type === 'pattern' && (
                        <p className={classes.errorText}>
                          {'فرمت فیلد شماره ثابت صحیح نیست'}
                        </p>
                      )}
                    {errors.homePhoneNumber &&
                      errors.homePhoneNumber.type === 'minLength' && (
                        <p className={classes.errorText}>
                          {'مقدار شماره ثابت نباید کمتر از 11 کاراکتر باشد'}
                        </p>
                      )}
                    {errors.homePhoneNumber &&
                      errors.homePhoneNumber.type === 'maxLength' && (
                        <p className={classes.errorText}>
                          {'مقدار شماره ثابت نباید بیشتر از 15 کاراکتر باشد'}
                        </p>
                      )}
                  </Grid>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPostOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="warrantyType"
                      name="warrantyType"
                      label="نوع ضمانت نامه"
                      className={classes.textInput}
                      InputLabelProps={{
                        shrink:
                          !!props.driver.warrantyType || !!values.warrantyType,
                      }}
                      inputRef={register({
                        required: false,
                      })}
                      error={errors.warrantyType && true}
                    />
                  </Grid>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCurrencyUsd}
                      size={1}
                      className={classes.icon}
                    />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="warrantyAmount"
                      name="warrantyAmount"
                      label="مبلغ ضمانت نامه (تومان)"
                      type="number"
                      className={classes.textInput}
                      InputLabelProps={{
                        shrink:
                          !!props.driver.warrantyAmount ||
                          !!values.warrantyAmount,
                      }}
                      inputRef={register({
                        required: false,
                      })}
                      error={errors.warrantyAmount && true}
                    />
                  </Grid>
                </div>
              </Grid>
              <Grid container item xs={12} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiMapMarkerOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>
                  <Grid item xs={11}>
                    <TextField
                      fullWidth
                      id="address"
                      name="address"
                      label="آدرس"
                      className={classes.textInput}
                      InputLabelProps={{
                        shrink: !!props.driver.address || !!values.address,
                      }}
                      inputRef={register({
                        required: false,
                        minLength: 10,
                        maxLength: 200,
                      })}
                      error={errors.address && true}
                    />
                    {errors.address && errors.address.type === 'minLength' && (
                      <p className={classes.errorText}>
                        {'مقدار آدرس نباید کمتر از 10 کاراکتر باشد'}
                      </p>
                    )}
                    {errors.address && errors.address.type === 'maxLength' && (
                      <p className={classes.errorText}>
                        {'مقدار آدرس نباید بیشتر از 200 کاراکتر باشد'}
                      </p>
                    )}
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </Paper>
          <Grid item container xs={12} justify="flex-end">
            <Grid item>
              <Button
                type="submit"
                fullWidth
                size="large"
                data-cy="search"
                autoFocus
                variant="contained"
                color="secondary"
                disabled={checkEmptyInputs()}
              >
                {'ویرایش اطلاعات'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  driver: makeSelectDriver(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    updateDriverDispatch: (payload: Payload) =>
      dispatch(updateDriverActions(payload)),
    getDriverWithIdActionDispatch: (id: number) =>
      dispatch(getDriverAction({ id })),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Index);
